
export enum FileType {
    SliderImage, Invoice, ProductImage, TestimonialImage, CategoryImage, DataImage, AboutUsImage, AboutusVideo, Label
}

export enum UserType {
    Admin, Subadmin, Consumer, Partner
}

export enum BankStatus {
    Pending, Approve, Reject
}
export enum WithdrawStatus {
    Requsted, Paid, Rejected
}
export enum AttachmentType {
    Image, Video
}

export enum RedirectType {
    Direct, Category, Product
}

export enum OrderStatus {
    All = -1, New, Accepted, Inprocess, OutForDelivery, Delivered, Cancelled
}

export enum PaymentMethod {
    COD, OnlinePayment, UPI, Others
}

export enum DiscountType {
    Flat, Percentage
}

export enum AddressType {
    Home, Office, Others
}

export enum ModuleLists {
    Home
}
export enum Operation {
    View, ViewandAdd, ViewAddandUpdate, ViewAddUpdateandDelete
}
export enum DataType {
    All = -1, Benifits, SkinType, Concern, KeyBenefits, Ingredients, HowToUse, ProductFaq
}

export enum InventoryType {
    In, Out
}
export enum AnalysticsType {

}
export enum AboutusType {
    Text, image, video
}

export enum DataPlace {
    HomePage, AboutusPage, Other
}

export enum Filter {
    AtoZ, ZtoA, LowPrice, HighPrice, Old, New
}

export enum OrderType {
    Website, Amazon, Flipkart, Blinkit, Zepto
}